import Flickity from "flickity";
import FlickityFade from "flickity-fade";
import SmoothScroll from "smooth-scroll";

var  imageBlocksEl = $('.image-blocks-carousel');
if (imageBlocksEl.length) {
	var imageBlocksCarousel = new Flickity( '.image-blocks-carousel', {
	  cellAlign: 'left',
		contain: true,
		pageDots: false,
		prevNextButtons: false,
		selectedAttraction: 0.2,
		friction: 0.8,
		draggable: false,
		cellSelector: '.image-block-cell'
	});

	imageBlocksEl.css({opacity: 1})	
}

Vue.component('leader', {
  props: {
    leader: Object
  },
  template: `
    <div class="team--member">
      <figure>
        <a href="#" class="fire-team-modal" data-toggle="modal" :data-target="'#leader-'+leader.id">
          <img class="img-responsive" :src="leader.photo" :alt="leader.name">
        </a>
      </figure>
      <h2 class="team-name"><a href="#" class="fire-team-modal" data-toggle="modal" :data-target="'#leader-'+leader.id">{{leader.name}}</a></h2>
      <h3 class="team-position" v-html="leader.position"></h3>
      <div class="team-bio" v-html="leader.bio">
      </div>
    </div>
  `
});


Vue.filter('stripJson', function (value) {
  if (!value) return ''
  return value.replace(/\"/g, "");
});

var app = new Vue({
  el: '#app',
  delimiters: ['${', '}'],
  data: {
    mobileMenu: false,
    servicePane: false,
    serviceData: {
      title: "",
      icon: "",
      body: ""
    },
    leaders: [],
    contactForm: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      department: '',
      comments: ''
    }
  },
  methods: {
  	fireMenu: function(e) {
  		if (this.mobileMenu == false) {
  			this.mobileMenu = true;
  		} else {
  			this.mobileMenu = false;
  		}
  	},
    scrollToServices: function(e) {
      this.mobileMenu = false;
    },
    fireService: function(title, body, icon, e) {
      if (this.servicePane == false) {
        this.servicePane = true;
        this.serviceData.title = title;
        this.serviceData.body = body;
        this.serviceData.icon = icon;
      } else {
        this.servicePane = false;
        this.serviceData.title = "";
        this.serviceData.body = "";
        this.serviceData.icon = "";
      }
    },
    removeService: function(e) {
      this.servicePane = false;
    }
  },
  mounted: function() {
    var scroll = new SmoothScroll('a[href*="#"]', {
      speed: 300
    });
    var clientsEl = $('.clients-carousel');
    if (clientsEl.length) {
      var clientsCarousel = new Flickity( '.clients-carousel', {
        cellAlign: 'left',
        wrapAround: true,
        autoPlay: 2500,
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
        cellSelector: '.clients-carousel--item'
      });

      clientsEl.css({opacity: 1})  
    }
    
    // Grab Leaders
    self = this;
    $.getJSON( "/leadership/leaders.json", function( json ) {
      self.leaders = json.leaders;
    }).fail(function(error1, error2, error3) {
       console.log(error1)
    });
  },
  updated: function() {
    $('.leader-body').each(function(index, el) {
      var thisBody = $(el).html();
      thisBody = thisBody.replace(/\"/g, "");
       $(this).html(thisBody);
    });
  }
});